import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { CriticalNotificationType } from 'components/CriticalNotification';

type CNotificationsType = {
  notifications: CriticalNotificationType[];
  isNotificationsLoaded: boolean;
};

const initialState: CNotificationsType = {
  notifications: [],
  isNotificationsLoaded: false,
};

const criticalNotificationsSlice = createAppSlice({
  name: 'criticalNotifications',
  initialState,
  reducers: {
    setCriticalNotificationsData: (
      state,
      action: PayloadAction<CNotificationsType['notifications']>,
    ) => {
      state.notifications = action.payload;
    },
    setCriticalNotificationsLoadStatus: (
      state,
      action: PayloadAction<CNotificationsType['isNotificationsLoaded']>,
    ) => {
      state.isNotificationsLoaded = action.payload;
    },
    criticalNotificationsReset: () => initialState,
  },
  selectors: {
    getCriticalNotifications: (notifications) => notifications.notifications,
    getCriticalNotificationsLoadingStatus: (notifications) =>
      notifications.isNotificationsLoaded,
  },
});

export const {
  setCriticalNotificationsData,
  criticalNotificationsReset,
  setCriticalNotificationsLoadStatus,
} = criticalNotificationsSlice.actions;
export const {
  getCriticalNotifications,
  getCriticalNotificationsLoadingStatus,
} = criticalNotificationsSlice.selectors;
export default criticalNotificationsSlice.reducer;
